<template>
  <SOSlotModal
      modal-title="Pengaturan Rekomendasi"
      :modal-id="id"
      :no-padding="true"
      @close="decline()"
  >
    <template v-slot:modal-body>
      <div class="p-4">
        <div class="d-flex align-items-baseline">
          <SOInputOnOff
              class="m-d-20"
              :checkboxes="activeServiceRecommendation"
              :checked="isChecked"
              @selected="(v) => (isChecked = v)"
          />
          <div class="f-16 f-c-primary">Rekomendasi Layanan</div>
        </div>
        <div class="f-14 f-c-midgrey">
          Layanan rekomendasi akan otomatis direkomendasikan oleh AI saat kasir
          membuat transaksi pada aplikasi Smartlink Kasir
        </div>
      </div>
    </template>
    <template v-slot:modal-footer>
      <div id="button" class="px-4 pb-2">
        <SOButton
            text="Simpan"
            primary
            :disable="disable"
            :loading="isLoading"
            :full="true"
            @action="onSave()"
        />
      </div>
    </template>
  </SOSlotModal>
</template>

<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOButton from "@/so-components/global/ui/SOButton";
import SOInputOnOff from "@/so-components/global/input/SOInputOnOff.vue";
import {mapActions} from "vuex";
import {moduleName} from "../../store/state";

export default {
  name: "ModalServiceRecommendationSetting",
  components: {
    SOSlotModal,
    SOButton,
    SOInputOnOff,
  },
  data() {
    return {
      id: "ModalServiceRecommendationSetting",
      resolve: null,
      activeServiceRecommendation: {
        data: [
          {
            id: "checkbox-activeServiceRecommendation",
            value: "1",
            checked: false,
            titleBold: false,
          },
        ],
      },
      isChecked: false,
      oldValue: null,
      isLoading: false,
    };
  },
  methods: {
    ...mapActions(moduleName, {
      updateActiveServiceRecommendation: "updateActiveServiceRecommendation",
    }),
    open(value) {
      this.isChecked = value;
      this.oldValue = this.isChecked;
      this.isLoading = false;
      return new Promise((resolve) => {
        this.resolve = resolve;
        $("#" + this.id).modal("show");
      });
    },
    confirm() {
      this.resolve(true);
    },
    decline() {
      this.resolve(false);
      this.close();
    },
    close() {
      $("#" + this.id).modal("hide");
      setTimeout(() => {
        this.$emit("close");
      }, 500);
    },
    onSave() {
      this.isLoading = true;
      this.updateActiveServiceRecommendation(
          {
            "enable_rekomendasi_layanan": this.isChecked ? 1 : 0,
          }
      )
          .then((r) => {
            if (r.success) {
              this.confirm();
              return;
            }
            this.isLoading = false;
            this.$toast.error(r.err);
          })
          .catch((e) => {
            this.$toast.error(e);
            console.log(e);
          });
    },
  },
  computed: {
    disable() {
      return this.loading || this.oldValue == this.isChecked;
    },
  },
};
</script>

<style scoped>
#button >>> .btn-outline-danger {
  margin-bottom: 1rem;
}
</style>
